/***
 * Created on 2024/4/16
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

export const qnapAuthReducer = (state, action) => {
    const resetState = () => {
        let new_state = {...state};
        for (const key in new_state) {
            if (key.startsWith('show')) {
                new_state[key] = false;
            }
        }
        return new_state;
    }

    if (action.type === 'toggleVerifyPassword') {
        let new_state = {
            ...resetState(),
            showVerifyPassword: action.value
        }
        if (action?.openAfterPassVerified) {
            new_state.openAfterPassVerified = action.openAfterPassVerified;
            new_state.method = action.method;
        }
        if (action?.opts) {
            new_state.opts = action.opts
            if (action.opts?.openAfterInstallApp) {
                new_state.openAfterInstallApp = action.opts.openAfterInstallApp;
            }
            if (action.opts?.newDevice) {
                new_state.newDevice = action.opts.newDevice;
            }
        }

        return new_state;
    }
    else if (action.type === 'toggleShowInitQnapAuthAppSetup') {
        let new_state = {
            ...resetState(),
            showInitQnapAuthAppSetup: action.value
        }
        if (action.opts?.newDevice) {
            new_state.newDevice = action.opts.newDevice;
        }
        return new_state;
    }
    else if (action.type === 'toggleShowInstallApp') {
        let new_state = {
            ...resetState(),
            showInstallApp: action.value,
        }
        if (action?.openAfterInstallApp) {
            new_state.openAfterInstallApp = action.openAfterInstallApp;
        }
        if (action?.method) {
            new_state.method = action.method;
        }
        if (action?.setupAction) {
            new_state.setupAction = action.setupAction;
        }
        return new_state;
    }
    else if (action.type === 'toggleShowQrCodeScan') {
        return {
            ...resetState(),
            showQrCodeScan: action.value,
        }
    }
    else if (action.type === 'toggleShowApproval') {
        return {
            ...resetState(),
            showApproval: action.value,
        }
    }
    else if (action.type === 'toggleShowSuccess') {
        return {
            ...resetState(),
            showSuccess: action.value,
            device: action.device
        }
    }
    else if (action.type === 'toggleShowInitSetup') {
        return {
            ...resetState(),
            showInitAppSetup: action.value,
        }
    }
    else if (action.type === 'toggleShowInitSMSSetup') {
        return {
            ...resetState(),
            showInitSMSSetup: action.value
        }
    }
    else if (action.type === 'toggleShowAuthAppSetup') {
        return {
            ...resetState(),
            showAuthAppSetup: action.value
        }
    }
    else if (action.type === 'toggleAddPhone') {
        let new_state = {
            ...resetState(),
            showAddPhone: action.value
        }
        if (action?.opts) {
            new_state.opts = action.opts
        }
        return new_state;
    }
    else if (action.type === 'toggleDisable') {
        return {
            ...resetState(),
            showDisableDialog: action.value
        }
    }
    else if (action.type === 'toggleRemoveMethod') {
        let new_state = {
            ...resetState(),
            showRemoveMethod: action.value
        }
        if (action?.opts) {
            new_state.opts = action.opts
        }
        return new_state;
    }
    else if (action.type === 'toggleSigninAgain') {
        return {
            ...resetState(),
            showSigninAgain: action.value
        }
    }
    else if (action.type === 'toggleManageSetup') {
        let new_state = {
            ...resetState(),
            showManageSetup: action.value
        }

        if (action?.method) {
            new_state.method = action.method
        }

        return new_state;
    }
    else if (action.type === 'toggleQnapAuthSetupSuccess') {
        return {
            ...resetState(),
            showQnapAuthSetupSuccess: action.value,
            method: action?.method
        }
    }
    else if (action.type === 'updateSMSPanel') {
        return {
            ...resetState(),
            refreshSMSPanel: state.refreshSMSPanel+1
        }
    }
    else {
        return state;
    }
}

export const initState = {
    showVerifyPassword: false,
    showInitAppSetup: false,
    showInitSMSSetup: false,
    showAuthAppSetup: false,
    showAddPhone: false,
    showDisableDialog: false,
    showRemoveMethod: false,
    showSigninAgain: false,

    showInitQnapAuthAppSetup: false,
    showInstallApp: false,
    showQrCodeScan: false,
    showApproval: false,
    showSuccess: false,

    showManageSetup: false,

    showQnapAuthSetupSuccess: false,

    refreshSMSPanel: 0
}
